export default __webpack_public_path__ + "static/media/fiveYard.30da14e3.jpg";